import axios from 'axios';
import { IViaCepData } from 'src/interfaces/global';

async function getCep(zipCode: string): Promise<IViaCepData> {
  const response = await axios.get(`https://viacep.com.br/ws/${zipCode}/json/`);

  return response.data;
}

export const apiGlobal = {
  getCep,
};
